// React
import React from "react";

// External libraries
import { faCheck, faHorizontalRule } from "@fortawesome/sharp-regular-svg-icons";

// Internal
import { FontAwesome } from "../icons/icons";
import { Tooltip } from "../tooltip/tooltip";

// CSS
import "./forms.css";
import "./checkbox.css";

function FormCheckbox(props) {
    const changeHandler = (e) => {
        if (typeof props.OnChange === "function") {
            props.OnChange(props.Data);
        }
        if (typeof props.OnToggle === "function") {
            props.OnToggle(e.target.checked);
        }
    };

    const getStyle = () => {
        const style = {};
        if (props.NoPadding) style.padding = "0px";
        return style;
    };

    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    if (props.Skeleton) {
        return (
            <div className={props.Inline ? "eone-ui-form-checkbox-inline-container" : "eone-ui-form-checkbox-container"} title={props.Title} style={getStyle()}>
                <label className="eone-ui-form-checkbox">
                    <input type="checkbox" className="eone-ui-form-checkbox-skeleton" disabled data-testid={props.DataTestId} />
                    <span className="eone-ui-form-checkbox-label">{props.Label}</span>
                </label>
            </div>
        );
    }
    return (
        <div className={props.Inline ? "eone-ui-form-checkbox-inline-container" : "eone-ui-form-checkbox-container"} title={props.Title} style={getStyle()}>
            <Checkbox
                OnChange={changeHandler}
                Value={props.Value}
                ReadOnly={props.ReadOnly}
                DataTestId={props.DataTestId}
                Label={props.Label} />
            <Tooltip
                Title={props.TooltipTitle ? props.TooltipTitle : props.Label}
                Tooltip={props.Tooltip}
                TooltipTitle={props.TooltipTitle}
                TooltipWidth={props.TooltipWidth}
                DataTestId={props.DataTestId} />
        </div>
    );
}

function Checkbox(props) {
    const getStyle = () => {
        const style = { ...(props.Style ?? {}) };
        if (props.Center) style.justifyContent = "center";
        return style;
    }

    return (
        <label className="eone-ui-form-checkbox" style={getStyle()}>
            <input type="checkbox" onChange={props.OnChange} checked={!!props.Value || !!props.IsIndeterminate} disabled={props.ReadOnly} data-testid={props.DataTestId} />
            <span className="eone-ui-form-checkmark-container">
                <FontAwesome Icon={props.IsIndeterminate ? faHorizontalRule : faCheck} Size="sm" ClassName="eone-ui-form-checkmark" />
            </span>
            {props.Label &&
                <span className="eone-ui-form-checkbox-label">{props.Label}</span>
            }
        </label>
    );
}

export { FormCheckbox, Checkbox };